import { render, staticRenderFns } from "./MediaDetail.vue?vue&type=template&id=1636bd3a&"
import script from "./MediaDetail.vue?vue&type=script&lang=js&"
export * from "./MediaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1636bd3a')) {
      api.createRecord('1636bd3a', component.options)
    } else {
      api.reload('1636bd3a', component.options)
    }
    module.hot.accept("./MediaDetail.vue?vue&type=template&id=1636bd3a&", function () {
      api.rerender('1636bd3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/MediaDetail.vue"
export default component.exports